import { getAPIErrorReason } from '../helpers/common';
import axios from 'axios';
import { REACT_APP_TEAMCAMP_APIURL } from '../global/environment';
import { captureException } from './logService';
import { rootStore } from '../mobx/rootStore';

export const getSearchedGIF = async (searchedText: string) => {
  try {
    rootStore.chatMessageStore.setLoading(true);

    const response = await axios.get(`${REACT_APP_TEAMCAMP_APIURL}/giphy?text=${searchedText}`);
    if (response) {
      return response?.data;
    }
    return false;
  } catch (e) {
    const error = getAPIErrorReason(e) || 'Unable to search GIF, please try again later';
    captureException(error);
    dispatchChatMessageError(error);
    return false;
  } finally {
    rootStore.chatMessageStore.setLoading(false);
  }
};

/**
 * @desc Message - get improved text
 * @param {*}
 */
export const getImprovedText = async (text: string) => {
  try {
    rootStore.chatMessageStore.setLoading(true);

    const response = await axios.post(`${REACT_APP_TEAMCAMP_APIURL}/openai/getImprovedText`, { text });
    if (response?.data) {
      return response?.data;
    }
    return false;
  } catch (e) {
    const error = getAPIErrorReason(e) || 'Unable to get improved text, please try again later';
    captureException(error);
    dispatchChatMessageError(error);
  } finally {
    rootStore.chatMessageStore.setLoading(false);
  }
};

export function dispatchChatMessageError(msg: string) {
  rootStore.alertNotificationStore.setErrorMessage(msg);
}

export function dispatchChatMessageSuccess(msg: string) {
  rootStore.alertNotificationStore.setSuccessMessage(msg);
}
